import React, { useEffect, useState } from 'react';

export type SwitchOption = {
  id: string;
  name: string;
  icon: JSX.Element;
};

type SwitchButtonsProps = {
  isIcons?: boolean;
  options: SwitchOption[];
  defaultActive?: string;
  onChange?: (value: string) => void;
};

const SwitchButtons: React.FC<SwitchButtonsProps> = ({
  isIcons,
  options,
  defaultActive,
  onChange,
}) => {
  const [active, setActive] = useState<string>(defaultActive ?? options[0]?.id);

  useEffect(() => {
    if (defaultActive) {
      setActive(defaultActive);
    }
  }, [defaultActive]);

  const handleClick = (id: string) => {
    setActive(id);
    onChange?.(id);
  };

  return (
    <div className='switch-toggle'>
      {options.map((item) => (
        <button
          key={item.id}
          type='button'
          className={`switch-btn ${active === item.id ? 'active' : ''}`}
          onClick={() => handleClick(item.id)}
        >
          {isIcons ? item?.icon : item?.name}
        </button>
      ))}
    </div>
  );
};

export default SwitchButtons;
